// 用于表格中点击跳转后，自动填充
export default {
    namespaced: true,
    state: {
        xf_soft: "云飞阁", //续费软件
        xf_name: "", //续费账号
        xf_term: "", //续费期限
        gm_soft: "云飞阁", //改密软件
        gm_name: "", //改密账号
    },
    mutations: {
        changexfSoft(state, payload) {
            state.xf_soft = payload;
        },
        changexfName(state, payload) {
            state.xf_name = payload;
        },
        changexfTerm(state, payload) {
            state.xf_term = payload;
        },
        changegmSoft(state, payload) {
            state.gm_soft = payload;
        },
        changegmName(state, payload) {
            state.gm_name = payload;
        },
    }
}